import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STYLES = [
    { id: 'minimalist', name: 'Minimaliste', img: 'https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?auto=format&fit=crop&w=1000&q=80', tags: ['Epure', 'Blanc', 'Simple'] },
    { id: 'luxury', name: 'Premium & Luxe', img: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1000&q=80', tags: ['Or', 'Noir', 'Élégance'] },
    { id: 'tech', name: 'High-Tech', img: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1000&q=80', tags: ['Néon', 'Cyber', 'Futur'] },
    { id: 'organic', name: 'Nature & Organique', img: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1000&q=80', tags: ['Vert', 'Doux', 'Frais'] },
    { id: 'industrial', name: 'Industriel', img: 'https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?auto=format&fit=crop&w=1000&q=80', tags: ['Brut', 'Béton', 'Urbain'] },
    { id: 'pop', name: 'Pop & Coloré', img: 'https://images.unsplash.com/photo-1549887552-93f8efb88132?auto=format&fit=crop&w=1000&q=80', tags: ['Vif', 'Dynamique', 'Jeune'] },
    { id: 'corporate', name: 'Corporate', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1000&q=80', tags: ['Sérieux', 'Bleu', 'Confiance'] },
];

export default function CommercialMoodboardPage() {
    const navigate = useNavigate();
    const [step, setStep] = useState('intro'); // intro, swipe, result
    const [currentIndex, setCurrentIndex] = useState(0);
    const [likedStyles, setLikedStyles] = useState([]);
    const [direction, setDirection] = useState(null); // 'left' or 'right' animation

    const currentCard = STYLES[currentIndex];

    const handleSwipe = (liked) => {
        setDirection(liked ? 'right' : 'left');

        if (liked) setLikedStyles([...likedStyles, currentCard]);

        setTimeout(() => {
            if (currentIndex < STYLES.length - 1) {
                setCurrentIndex(prev => prev + 1);
                setDirection(null);
            } else {
                setStep('result');
            }
        }, 300); // Wait for transition
    };

    if (step === 'intro') {
        return (
            <div className="moodboard-page">
                <div style={{ maxWidth: 600, textAlign: 'center', zIndex: 10 }}>
                    <div style={{ fontSize: '4rem', marginBottom: 20 }}>🎨</div>
                    <h1 style={{ fontSize: '3rem', fontWeight: 800, marginBottom: 20, color: 'white' }}>Moodboard Express</h1>
                    <p style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.7)', marginBottom: 50, lineHeight: 1.6 }}>
                        Découvrons ensemble votre identité visuelle.<br />
                        Swipez à droite si vous aimez, à gauche sinon.
                    </p>
                    <button
                        onClick={() => setStep('swipe')}
                        style={{ padding: '20px 40px', fontSize: '1.2rem', fontWeight: 700, borderRadius: 50, border: 'none', background: 'white', color: 'black', cursor: 'pointer', boxShadow: '0 10px 25px rgba(255,255,255,0.2)' }}
                    >
                        Commencer l'expérience →
                    </button>
                    <button
                        onClick={() => navigate('/commercial/launchpad')}
                        style={{ display: 'block', margin: '30px auto', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}
                    >
                        Retour
                    </button>
                </div>
                <BackgroundOverlay />
            </div>
        );
    }

    if (step === 'swipe') {
        return (
            <div className="moodboard-page">
                <div style={{ position: 'relative', width: '90%', maxWidth: 500, height: '70vh', perspective: 1000 }}>

                    {/* Card Stack Background (Decoration) */}
                    <div style={{ position: 'absolute', top: 20, left: 0, right: 0, bottom: -20, background: 'rgba(255,255,255,0.1)', borderRadius: 24, transform: 'scale(0.95)' }} />

                    {/* Active Card */}
                    <div
                        className={`swipe-card ${direction === 'left' ? 'fly-left' : direction === 'right' ? 'fly-right' : ''}`}
                        style={{
                            background: `url(${currentCard.img}) center/cover`,
                            position: 'absolute', inset: 0, borderRadius: 24,
                            boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
                            display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: 30
                        }}
                    >
                        <div style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(10px)', padding: 20, borderRadius: 16 }}>
                            <h2 style={{ margin: 0, fontSize: '2rem', color: 'white' }}>{currentCard.name}</h2>
                            <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                                {currentCard.tags.map(t => (
                                    <span key={t} style={{ border: '1px solid rgba(255,255,255,0.3)', padding: '4px 12px', borderRadius: 20, fontSize: '0.8rem', color: 'white' }}>{t}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Controls */}
                <div style={{ display: 'flex', gap: 30, marginTop: 40, zIndex: 10 }}>
                    <button onClick={() => handleSwipe(false)} className="action-btn btn-no">❌</button>
                    <button onClick={() => handleSwipe(true)} className="action-btn btn-yes">💚</button>
                </div>

                <div style={{ marginTop: 20, color: 'rgba(255,255,255,0.4)' }}>
                    {currentIndex + 1} / {STYLES.length}
                </div>

                <BackgroundOverlay />
            </div>
        );
    }

    if (step === 'result') {
        return (
            <div className="moodboard-page" style={{ overflowY: 'auto', display: 'block', padding: 50 }}>
                <div style={{ maxWidth: 800, margin: '0 auto' }}>
                    <h2 style={{ fontSize: '2.5rem', color: 'white', marginBottom: 10 }}>Votre ADN Design ✨</h2>
                    <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: 40 }}>Voici les styles qui vous correspondent le plus.</p>

                    {likedStyles.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 40, background: 'rgba(255,255,255,0.05)', borderRadius: 20, color: 'white' }}>
                            Vous êtes très exigeant ! Aucun style retenu. 😉
                        </div>
                    ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 20, marginBottom: 40 }}>
                            {likedStyles.map(s => (
                                <div key={s.id} style={{ borderRadius: 16, overflow: 'hidden', position: 'relative', aspectRatio: '1' }}>
                                    <img src={s.img} alt={s.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 10, background: 'linear-gradient(transparent, rgba(0,0,0,0.8))', color: 'white', fontWeight: 600 }}>
                                        {s.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: 20 }}>
                        <button onClick={() => navigate('/commercial/launchpad')} style={{ flex: 1, padding: 20, borderRadius: 12, background: 'rgba(255,255,255,0.1)', color: 'white', border: 'none', fontSize: '1.1rem', cursor: 'pointer', fontWeight: 600 }}>Retour Accueil</button>
                        <button onClick={() => { alert('Planche enregistrée dans le dossier client !'); navigate('/commercial/launchpad'); }} style={{ flex: 1, padding: 20, borderRadius: 12, background: 'white', color: 'black', border: 'none', fontSize: '1.1rem', cursor: 'pointer', fontWeight: 600 }}>💾 Enregistrer</button>
                    </div>
                </div>
                <BackgroundOverlay />
            </div>
        );
    }
}

function BackgroundOverlay() {
    return (
        <>
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom right, #1e1b4b, #312e81, #4c1d95)', zIndex: -1 }} />
            <style>{`
                .moodboard-page {
                    height: 100vh; width: 100vw; overflow: hidden;
                    display: flex; flex-direction: column; align-items: center; justify-content: center;
                    font-family: 'Inter', sans-serif; position: relative;
                }
                .swipe-card { transition: transform 0.3s ease, opacity 0.3s ease; }
                .fly-left { transform: translateX(-150%) rotate(-20deg) !important; opacity: 0; }
                .fly-right { transform: translateX(150%) rotate(20deg) !important; opacity: 0; }
                
                .action-btn {
                    width: 70px; height: 70px; borderRadius: 50%; border: none;
                    background: white; font-size: 2rem; cursor: pointer;
                    box-shadow: 0 10px 20px rgba(0,0,0,0.2);
                    transition: transform 0.2s; display: grid; place-items: center;
                }
                .action-btn:hover { transform: scale(1.1); }
                .btn-no { color: #ef4444; }
                .btn-yes { color: #10b981; }
            `}</style>
        </>
    );
}
